import { useEffect, useState } from "react";
import HeaderLogo from "../components/HeaderLogo";
import PageName from "../components/PageName";
import { useSelector } from "react-redux";
import Svg from "../components/figs/Svg";
// import UploadImage from "../components/UploadImage";
import { useForm, Controller } from "react-hook-form";
import { CropImage } from "../components/CropImage";
import { checkImageDataType, fetchAuthPost } from "../functions/functions";
import api from "../routes/api";
import { useAlertModal } from "../hooks/useAlertModal";
import { useConfirmModal } from "../hooks/useConfirmModal";
import Loading from "../components/Loading";
import MultiSelect from "../components/MultiSelect";
import useStaticData from "../hooks/useStaticData";
import ButtonBack from "../components/ButtonBack";
import { useContentModal } from "../hooks/useContentModal";
import CustomTimePicker from "../components/CustomTimePicker";

export default function TourManagement() {
  const { msg } = useSelector((s) => s.language);
  const { staticData } = useStaticData();
  const { tripDurationList } = staticData;

  const [isLoading, setIsLoading] = useState(true);
  const [isAddNew, setIsAddNew] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(true);
  const [tourList, setTourList] = useState(null);
  const [filterTourList, setFilterTourList] = useState([]);
  const [destinationList, setDestinationList] = useState([]);
  const [showButtonBack, setShowButtonBack] = useState(false);

  const { alert, AlertModal } = useAlertModal();
  const { confirm, ConfirmModal } = useConfirmModal();
  const { setContent, setTitle, handleOpen, handleClose, ContentModal } =
    useContentModal();

  const {
    register,
    setValue,
    trigger,
    handleSubmit,
    watch,
    getValues,
    reset,
    control,
    formState: { errors },
  } = useForm();
  const image = watch("image");
  const id_trip_duration = watch("id_trip_duration");
  const id_destination_list = watch("id_destination_list");
  const departure_time = watch("departure_time");

  const onAddNewDestination = async (destination) => {
    const res = await fetchAuthPost(api.setting.createDestination, {
      data: { destination },
    });
    if (res.status === "success") {
      const fetchDestinationList = await fetchAuthPost(
        api.setting.readDestinationList
      );
      setDestinationList(fetchDestinationList.data);
    } else {
      alert(msg.alert, res.msg);
    }
  };

  const onAddNew = () => {
    setShowButtonBack(true);
    setIsAddNew(true);
    setIsEdit(false);
    setIsView(false);
    reset({
      id_destination_list: [],
    });
  };
  const onSubmitImage = (src) => {
    setValue("image", src);
    trigger("image");
    if (src) {
      handleClose();
    }
  };

  const onEdit = (data) => {
    setShowButtonBack(true);
    setIsEdit(true);
    setIsView(false);
    reset(data);
  };

  const onView = (data) => {
    setShowButtonBack(true);
    setIsEdit(true);
    setIsView(true);
    reset(data);
  };
  const onFilter = (e) => {
    const value = e.target.value;
    if (value.length > 0) {
      const temp = tourList
        .map((el) => ({
          ...el,
          // destination: destinationList.find(
          //   (el2) => +el2.id_destination === +el.id_destination
          // ).destination,
          // trip_duration: tripDurationList.find(
          //   (el2) => +el2.id_trip_duration === +el.id_trip_duration
          // ).trip_duration,
        }))
        .filter((el) => {
          return (
            `${el.tour_name}`.toLowerCase().includes(value.toLowerCase()) ||
            // `${el.id_destination}`
            //   .toLowerCase()
            //   .includes(value.toLowerCase()) ||
            // `${el.id_trip_duration}`
            //   .toLowerCase()
            //   .includes(value.toLowerCase()) ||
            `${el.day}`.toLowerCase().includes(value.toLowerCase()) ||
            `${el.departure_time}`
              .toLowerCase()
              .includes(value.toLowerCase()) ||
            `${el.arrival_time}`.toLowerCase().includes(value.toLowerCase()) ||
            `${el.destination}`.toLowerCase().includes(value.toLowerCase()) ||
            `${el.trip_duration}`.toLowerCase().includes(value.toLowerCase())
          );
        });
      setFilterTourList(temp);
    } else {
      setFilterTourList([]);
    }
  };

  const onCancel = () => {
    setShowButtonBack(false);
    setIsAddNew(false);
    setIsEdit(false);
    reset({});
    setFilterTourList([]);
  };

  const onDelete = async (id_tour) => {
    try {
      const isConfirmDelete = await confirm(
        msg.delete_tour,
        msg.are_you_sure_want_to_delete_this_tour
      );
      if (isConfirmDelete) {
        setIsLoading(true);
        const response = await fetchAuthPost(api.setting.deleteTour, {
          data: { id_tour },
        });
        if (response.status === "error") {
          return alert(msg.alert, response.msg);
        }
        const responseTourList = await fetchAuthPost(api.setting.readTourList);
        setTourList(responseTourList.data);
        setFilterTourList([]);
      }
    } catch (error) {
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const onSubmit = async (data) => {
    try {
      const imageDataType = checkImageDataType({ src: data.image });
      let imageSrc = null;
      if (imageDataType === "url") {
        const result = await fetchAuthPost(
          api.utils.getImageUriByImageUrlInGcs,
          {
            imageUrl: data.image,
          }
        );
        imageSrc = result.data;
      } else if (imageDataType === "base64") {
        imageSrc = data.image;
      }
      const isNight =
        tripDurationList.find(
          (el) => +el.id_trip_duration === +data.id_trip_duration
        )?.name === "overnight";

      const payload = {
        tour_name: data.tour_name,
        id_trip_duration: +data.id_trip_duration,
        night: isNight ? +data.night : null,
        departure_time: data.departure_time,
        arrival_time: data.arrival_time,
        image: imageSrc,
        id_destination_list: data.id_destination_list,
      };

      const payloadCreate = payload;
      const payloadUpdate = {
        id_tour: data?.id_tour,
        ...payload,
      };

      setIsLoading(true);
      let response = null;
      if (data.id_tour) {
        response = await fetchAuthPost(api.setting.updateTour, {
          data: payloadUpdate,
        });
        if (response.status === "error") {
          return alert(msg.alert, response.msg);
        }
      } else {
        response = await fetchAuthPost(api.setting.createTour, {
          data: payloadCreate,
        });
        if (response.status === "error") {
          return alert(msg.alert, response.msg);
        }
      }
      if (response.status === "success") {
        response = await fetchAuthPost(api.setting.readTourList);
        setIsAddNew(false);
        setIsEdit(false);
        reset({});
        setTourList(response.data);
        setShowButtonBack(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  const initFetch = async () => {
    const fetchTourList = await fetchAuthPost(api.setting.readTourList);
    setTourList(fetchTourList.data);
    const fetchDestinationList = await fetchAuthPost(
      api.setting.readDestinationList
    );
    setDestinationList(fetchDestinationList.data);
  };
  const onSelectOption = (data) => {
    setValue(
      "id_destination_list",
      data.map((el) => el.value)
    );
  };
  useEffect(() => {
    initFetch();
    setValue("id_trip_duration", 1);
    setValue("id_destination_list", []);
  }, []);
  useEffect(() => {
    if (isAddNew) {
      setValue("id_trip_duration", 1);
    }
  }, [isAddNew]);
  useEffect(() => {
    if (isEdit || isView) {
      setValue("id_trip_duration", id_trip_duration);
    }
  }, [isEdit, isView]);
  useEffect(() => {
    if (id_destination_list?.length > 0) {
      trigger("id_destination_list");
    }
  }, [id_destination_list]);
  useEffect(() => {
    if (destinationList.length >= 0 && tourList?.length >= 0) {
      setIsLoading(false);
    }
  }, [destinationList, tourList]);
  if (isLoading) return <Loading />;
  return (
    <div className="page_tour_management">
      <ButtonBack
        hidden={!showButtonBack}
        onClick={() => {
          onCancel();
        }}
      />
      <HeaderLogo />
      <PageName titleName={msg.tour_management} />
      {isAddNew === false && isEdit === false && (
        <div className="data_container">
          <div className="data_card_list_header">
            <span className="left_at_header">{msg["tour_list(s)"]}</span>
            <span className="right_at_header">
              <span>
                <Svg iconName="search" className="size-4" />
                <input onChange={onFilter} placeholder={msg.search} />
              </span>
              <span>
                <button onClick={onAddNew}>{msg.add_new}</button>
              </span>
            </span>
          </div>
          <div className="data_card_list_body tour_list_body">
            {(filterTourList.length > 0 ? filterTourList : tourList).map(
              (el) => (
                <TourCard
                  key={el.id_tour}
                  data={{
                    ...el,
                    trip_duration: tripDurationList.find(
                      (el2) => +el2.id_trip_duration === +el.id_trip_duration
                    ).trip_duration,
                    destinationList: el.id_destination_list.map(
                      (el2) =>
                        destinationList.find(
                          (el3) => +el3.id_destination === +el2
                        )?.destination || []
                    ),
                  }}
                  onDelete={() => onDelete(el.id_tour)}
                  onView={() => onView(el)}
                  onEdit={() => onEdit(el)}
                />
              )
            )}
          </div>
        </div>
      )}
      {(isAddNew === true || isEdit === true) && (
        <div className="tour_form">
          <div className="_title_name_form">{msg.add_new_tour}</div>
          <div className="tour_form_body">
            <div className="form_text">
              <div className="_input_text_select">
                <label>{`${msg.tour_name} *`}</label>
                <input
                  placeholder={msg.tour_name}
                  {...register("tour_name", {
                    required: true,
                  })}
                  className={errors.tour_name ? "_data_invalid" : ""}
                  disabled={isView}
                />
              </div>
              <input
                type="hidden"
                {...register("id_destination_list", { required: true })}
              />
              <div className={`_input_text_select`}>
                <label>{`${msg.destination} *`}</label>
                <MultiSelect
                  className={errors.id_destination_list ? "_data_invalid" : ""}
                  disabled={isView}
                  placeholder={msg.destination}
                  onSaveNewOption={onAddNewDestination}
                  onSelectOption={onSelectOption}
                  selectedOption={id_destination_list.map((el) => ({
                    value: el,
                    label: destinationList.find(
                      (el2) => +el2.id_destination === +el
                    ).destination,
                  }))}
                  options={destinationList.map((el) => ({
                    value: el.id_destination,
                    label: el.destination,
                  }))}
                />
              </div>
              <div>
                {tripDurationList.map((el) => (
                  <div key={el.id_trip_duration} className="_input_radio">
                    <input
                      type="radio"
                      {...register("id_trip_duration", { required: true })}
                      value={+el.id_trip_duration}
                      checked={+id_trip_duration === +el.id_trip_duration}
                      disabled={isView}
                    />
                    <label>{el.trip_duration}</label>
                  </div>
                ))}
              </div>
              <>
                <div className="day_departure_time">
                  {tripDurationList.find(
                    (el2) => +el2.id_trip_duration === +id_trip_duration
                  )?.name === "overnight" && (
                    <div className="_input_text_select night">
                      <label>{`${msg.night} *`}</label>
                      <input
                        placeholder={0}
                        {...register("night", {
                          required: true,
                        })}
                        className={errors.night ? "_data_invalid" : ""}
                        disabled={isView}
                      />
                    </div>
                  )}
                  <div className="_input_text_select">
                    <label>{`${msg.departure_time} *`}</label>
                    {/* <input
                      type="time"
                      placeholder={msg.departure_time}
                      {...register("departure_time", {
                        required: true,
                      })}
                      className={errors.departure_time ? "_data_invalid" : ""}
                      disabled={isView}
                    /> */}
                    <Controller
                      control={control}
                      name="departure_time"
                      rules={{ required: true }}
                      render={({ field }) => (
                        <CustomTimePicker
                          onChange={field.onChange}
                          value={field.value}
                          placeholder="06:00"
                          disabled={isView}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="_input_text_select">
                  <label>{`${msg.arrival_time} *`}</label>
                  <Controller
                    control={control}
                    name="arrival_time"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <CustomTimePicker
                        onChange={field.onChange}
                        value={field.value}
                        minTime={departure_time}
                        placeholder={"18:00"}
                        disabled={isView || !departure_time}
                      />
                    )}
                  />
                  {/* <input
                    type="time"
                    min={departure_time || "01:00"}
                    placeholder={msg.arrival_time}
                    {...register("arrival_time", {
                      required: true,
                    })}
                    className={errors.arrival_time ? "_data_invalid" : ""}
                    disabled={isView || !departure_time}
                  /> */}
                </div>
              </>
            </div>
            <input type="hidden" {...register("image")} />
            <div className="form_image">
              <div className="_input_text_select">
                <div
                  className="button_upload_image"
                  onClick={() => {
                    if (isView) return;
                    setTitle(msg.upload_image);
                    setContent(
                      <div style={{ padding: 20 }}>
                        <CropImage
                          setSrc={(src) => onSubmitImage(src.src)}
                          existingImage={image}
                        />
                      </div>
                    );
                    handleOpen();
                  }}
                >
                  {image ? (
                    <img src={image} alt="tour_image" />
                  ) : (
                    <>
                      <Svg iconName="empty_image" />
                      <span>{msg.upload_image}</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="button_add_tour">
            {isView ? (
              <button onClick={() => setIsView(false)} className="_fill_button">
                {msg.edit}
              </button>
            ) : (
              <>
                <button className="_outline_button" onClick={onCancel}>
                  {msg.cancel}
                </button>
                <button
                  onClick={handleSubmit(onSubmit)}
                  className="_fill_button"
                >
                  {getValues("id_tour") ? msg.update : msg.save}
                </button>
              </>
            )}
          </div>
        </div>
      )}
      {AlertModal}
      {ConfirmModal}
      {ContentModal}
    </div>
  );
}

const TourCard = ({ data, onEdit, onView, onDelete }) => {
  return (
    <div className="tour_card">
      <div onClick={onView} className="tour_card_image">
        {data.image ? (
          <img src={data.image} alt={data.tour_name} />
        ) : (
          <Svg iconName="empty_image" />
        )}
      </div>
      <div className="tour_card_detail">
        <div>
          <h2>{data.tour_name}</h2>
        </div>
        <div>
          <Svg iconName="clock" />
          <span>{data.trip_duration}</span>
        </div>
        <div>
          <Svg iconName="location" />
          <span>{`${data.destinationList.join(", ")}`}</span>
        </div>
        <div>
          <button onClick={onEdit}>
            <Svg iconName="edit" />
          </button>
          <button onClick={onDelete}>
            <Svg iconName="delete" />
          </button>
        </div>
      </div>
    </div>
  );
};
